module.exports = __webpack_public_path__ + "static/media/d2ru.f6bf79ea.pdf";